import { Button, ButtonProps } from 'antd';
import React from 'react';
import './nice-button.styles.less';
import cn from 'classnames';

type TNiceType = 'orange' | 'blue' | 'darkBlue' | 'default';
interface INiceButtonProps extends ButtonProps {
  niceType?: TNiceType;
  hidden?: boolean;
  type?: 'link' | 'text' | 'ghost' | 'default' | 'primary' | 'dashed' | undefined;
}

export const NiceButton: React.FC<INiceButtonProps> = (props) => {
  const { children, className = '', niceType = 'default', onClick, disabled, size, hidden } = props;

  if (hidden) return null;
  // eslint-disable-next-line react/destructuring-assignment
  const btnCss = props.type === undefined ? `nice-button nice-button-${niceType}` : 'p-0';

  return (
    <Button
      {...props}
      className={cn(btnCss, { 'nice-button-small': size === 'small', 'nice-button-disable': disabled }, className)}
      htmlType={!onClick ? 'submit' : undefined}
      shape="round"
    >
      {children}
    </Button>
  );
};
